export default "__VITE_ASSET__BU_uzaRC__"